// this is an autogenerated file from DesignSystem/TasksViewForm/Content/Content/Patient/PatientPicker/Content/SearchResult/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_TasksViewForm_Content_Content_Patient_PatientPicker_Content_SearchResult($search_term: String!, $parent_company_id: uuid!) {
  vaxiom_persons_search(
    search_term: $search_term
    parent_company_id: $parent_company_id
    whole_parent_company: false
  ) {
    person: vaxiom_person {
      id
      _id
      first_name
      middle_name
      last_name
      gender
      birth_date
      # profile_pic_url
      patient {
        id
        _id
      }
      contact_method_associations {
        id
        email {
          id
          address
        }
        phone {
          id
          number
        }
        postal_address {
          id
          zip
        }
      }
    }
  }
}

`